
export function isDiscount(repo: { langCode: string,  }, currency: string): boolean {
    const domain = window.location.hostname;
    const startDate = Date.UTC(2025, 9, 1, 0,0,1);
    const endDate = Date.UTC(2025, 11, 31, 23, 59, 59);
    const now = Date.now()
    return repo.langCode === "da" && now > startDate && now < endDate && domain.endsWith('.dk') && currency === 'DKK';
}
